import { prepareCustomDate } from 'ziphy-web-shared/basic/utils/time';
import { getResourceCode } from '../';
import { $definitions, PROCEDURE_CATEGORY_SELECT_ID, PROCEDURE_STATUS_SELECT_ID, } from '../../definitions';
export class ProcedureExtractor {
    constructor(resource, additional = {}) {
        this._data = resource;
        this.additional = additional;
    }
    get data() {
        return this._data;
    }
    get code() {
        return getResourceCode(this.data.code);
    }
    get category() {
        return $definitions.selects.getValue(PROCEDURE_CATEGORY_SELECT_ID, this.data.category);
    }
    get status() {
        return $definitions.selects.getValue(PROCEDURE_STATUS_SELECT_ID, this.data.status || this.additional.status);
    }
    get statusReason() {
        return getResourceCode(this.data.statusReason);
    }
    get date() {
        return prepareCustomDate({
            dateTime: this.data.performedDate,
            string: this.data.performedString,
        });
    }
    get note() {
        return this.data.note;
    }
}
